import script from "./Assessment.vue?vue&type=script&setup=true&lang=ts"
export * from "./Assessment.vue?vue&type=script&setup=true&lang=ts"

import "./Assessment.vue?vue&type=style&index=0&id=37337494&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37337494"]])

export default __exports__